import { useParams } from '@tanstack/react-router';
import type { ProjectDetailsParams } from '.';
import * as ExtractDownload from './downloads/extract';

export function TabDetails() {
  const { projectId } = useParams({ strict: false }) as ProjectDetailsParams;

  // Remounts the form per project: it loads its project only on mount, and the project switcher keeps this tab open.
  return <ExtractDownload.TabDetails key={projectId} />;
}

export function MapChildren() {
  return <ExtractDownload.MapChildren />;
}
